// extracted by mini-css-extract-plugin
export default {"footer":"style_footer__epRXK","copy":"style_copy__A0Br1"};